(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pod-variant-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-pod-variant-content-root]';
    const CONTENT_SELECTORS = {
      origin: '[data-pod-origin-message]',
      description: '[data-pod-description]',
      production_shipping: '[data-pod-production-shipping]',
      returns: '[data-pod-returns]',
      material: '[data-pod-spec="material"]',
      dimensions: '[data-pod-spec="dimensions"]',
      whats_included: '[data-pod-spec="whats_included"]'
    };

    const getFieldHtml = (template, field) => {
      const fieldElement = template.content.querySelector(`[data-pod-field="${field}"]`);
      return fieldElement ? fieldElement.innerHTML.trim() : '';
    };

    const updateTarget = (target, html, field) => {
      if (!Object.prototype.hasOwnProperty.call(target.dataset, 'podFallback')) {
        target.dataset.podFallback = target.innerHTML;
      }

      const nextHtml = html || target.dataset.podFallback;
      target.innerHTML = nextHtml;

      if (['material', 'dimensions', 'whats_included'].includes(field)) {
        const row = target.closest('[data-pod-spec-row]');
        if (row) row.hidden = nextHtml.trim() === '';
      }
    };

    const applyVariantContent = (root, variantId) => {
      if (!variantId) return;
      const template = root.querySelector(`template[data-pod-variant-content="${CSS.escape(String(variantId))}"]`);
      if (!template) return;

      Object.entries(CONTENT_SELECTORS).forEach(([field, selector]) => {
        const html = getFieldHtml(template, field);
        document.querySelectorAll(selector).forEach((target) => updateTarget(target, html, field));
      });

      document.querySelectorAll('[data-pod-specifications]').forEach((specifications) => {
        const hasContent = Array.from(specifications.querySelectorAll('.liner-disclosure__spec')).some((row) => {
          if (row.hidden) return false;
          const value = row.querySelector('dd');
          return Boolean(value?.textContent.trim());
        });
        specifications.hidden = !hasContent;
      });
    };

    const initializeRoots = () => {
      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        if (root.dataset.podInitialized === 'true') return;
        root.dataset.podInitialized = 'true';
        applyVariantContent(root, root.dataset.initialVariantId);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeRoots, { once: true });
    } else {
      initializeRoots();
    }

    document.addEventListener('on:variant:change', (event) => {
      const variantId = event.detail?.variant?.id;
      if (!variantId) return;
      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => applyVariantContent(root, variantId));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
